import type { ReactNode } from 'react';
import { useNavigationItemActions } from '@atlassian/navigation-drag-and-drop/main';
import type { AnalyticsEventHandler } from '@atlassian/navigation-drag-and-drop/use-item-drop';

export type ReorderActionsRendererProps = {
	currentItems: Array<{ id: string; label: string }>;
	currentOrder: Array<{ menuId: string; visible: boolean }>;
	entityAri: string;
	ownerAri: string;
	fireAnalyticsEvent: AnalyticsEventHandler | undefined;
	item: { id: string; label: string };
	onClose: () => void;
};

/**
 * Shared component that renders reorder actions with access to onClose callback.
 * Used by boards, dashboards, filters, plans, and apps to allow the outer popup menu
 * to close when reordering is complete.
 */
export const ReorderActionsRenderer = ({
	currentItems,
	currentOrder,
	entityAri,
	ownerAri,
	fireAnalyticsEvent,
	item,
	onClose,
}: ReorderActionsRendererProps): ReactNode => {
	return useNavigationItemActions({
		currentItems,
		currentOrder,
		entityAri,
		ownerAri,
		fireAnalyticsEvent,
		// oxlint-disable-next-line typescript/consistent-type-assertions
		getItemId: (i) => (i as { id: string }).id,
		item,
		onActionComplete: onClose,
	});
};
